import {ReactElement} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {Placement} from "react-bootstrap/types";

export interface TooltipWrapperProps {
  toolTip?: string;
  children: ReactElement;
  className?: string;
  placement?: Placement;
}

/**
 * @deprecated: please use Tooltip instead.
 */
export const TooltipWrapper = ({children, toolTip, className, placement = "top"}: TooltipWrapperProps) => {
  if (!toolTip) {
    return children;
  }
  return (
    <OverlayTrigger
      placement={placement}
      overlay={(props) => (
        <Tooltip {...props} className={className}>
          {toolTip}
        </Tooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
};
